import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { MDSTheme } from '@marqvision/mds/core';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  itemWrapper: {
    display: 'grid',
    gap: '12px',
    justifyItems: 'center',
  },
  icon: {
    padding: '16px',
    borderRadius: '50%',
    backgroundColor: MDSTheme.palette.white,
    '& svg': {
      width: '36px',
      height: '36px',
      '& path': {
        fill: MDSTheme.palette.black,
      },
    },
  },
});

type ItemProps = {
  icon: React.ReactElement;
  label: string;
};

export const LeftPromotionInfoItem = (props: ItemProps) => {
  const { icon, label } = props;
  const classes = useStyles();

  return (
    <div className={classes.itemWrapper}>
      <div className={classes.icon}>{icon}</div>
      <MDSTypography variant="body" size="m" weight="medium" color="color/content/on_default_color">
        {label}
      </MDSTypography>
    </div>
  );
};
